import React from 'react'
import { useEffect } from 'react';
import  '../../../charting_library/charting_library.standalone';
import '../../../datafeeds/udf/dist/bundle'
import TradingView from '../../../charting_library/charting_library.standalone';

function AppComponenetChartHTML() {
	// function getParameterByName(name) {
	// 	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	// 	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	// 		results = regex.exec(location.search);
	// 	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	// }

	// function initOnReady() {
	// 	var datafeedUrl = "https://demo-feed-data.tradingview.com";
	// 	console.log(datafeedUrl, 'ini data feed url')

	// 	var widget = window.tvWidget = new TradingView.widget({
	// 		// debug: true, // uncomment this line to see Library errors and warnings in the console
	// 		fullscreen: true,
	// 		symbol: 'AAPL',
	// 		interval: '1D',
	// 		container: "tv_chart_container",

	// 		//	BEWARE: no trailing slash is expected in feed URL
	// 		datafeed: new Datafeeds.UDFCompatibleDatafeed(datafeedUrl),
	// 		library_path: "charting_library/",
	// 		locale: getParameterByName('lang') || "en",

	// 		disabled_features: ["use_localstorage_for_settings"],
	// 		enabled_features: ["study_templates"],
	// 		charts_storage_url: 'https://saveload.tradingview.com',
	// 		charts_storage_api_version: "1.1",
	// 		client_id: 'tradingview.com',
	// 		user_id: 'public_user_id',
	// 		debug: true,
    //         theme:"dark",
	// 	});
	// 	console.log(widget)
	// };
	// console.log(initOnReady(),'this is widtet')

	// useEffect(() => {
	// 	initOnReady()
	
	// //   return () => {
	// // 	second
	// //   }
	// }, [])
	
	// window.addEventListener('DOMContentLoaded', initOnReady, false);
  return (
	<div id="tv_chart_container"></div>
	)
}

export default AppComponenetChartHTML